export const geoapifyApiKey = '05c6aa34f59b4d9eb31861cbe527d464'
